import React from 'react';
import './AnimatedSun.css';

const SUN_IMAGE = 'https://customer-assets.emergentagent.com/job_event-landing-19/artifacts/pmpnpk4m_image.png';

/**
 * Rotating sun using a real photo with surrounding corona glow.
 */
const AnimatedSun = () => {
  return (
    <div className="animated-sun-wrapper" data-testid="animated-sun">
      {/* Outer glowing corona (pulsates) */}
      <div className="sun-corona" />

      {/* Mid-corona flares */}
      <div className="sun-corona-mid" />

      {/* The rotating sun image */}
      <div className="sun-body-rotator">
        <img
          src={SUN_IMAGE}
          alt="Soleil en rotation"
          className="sun-image"
          draggable={false}
        />
      </div>
    </div>
  );
};

export default AnimatedSun;
